import { createBrowserHistory } from "history";

export const customHistory = createBrowserHistory()